// academy5.js - シンプルなタブ切り替え版（オリジナルのacademy.jsを修正）

// jQueryとSplideがグローバルで利用可能であることを前提
/* global jQuery, Splide */

// パディング調整機能
jQuery(document).ready(function ($) {
	function updatePaddingTop() {
		let targetHeight = 0;
		let padding = 0;

		if (window.matchMedia('(max-width: 599px)').matches) {
			targetHeight = $('.sp-fv-image').outerHeight();
			padding = targetHeight - 200;
		} else if (
			window.matchMedia('(min-width: 600px) and (max-width: 767px)')
				.matches
		) {
			targetHeight = $('.sp-fv-image').outerHeight();
			padding = targetHeight - 300;
		} else if (window.matchMedia('(max-width: 768px)').matches) {
			targetHeight = $('.sp-fv-image').outerHeight();
			padding = targetHeight - 360;
		} else {
			targetHeight = $('.pc-fv-image').outerHeight();
			padding = targetHeight - 440;
		}

		if (targetHeight > 400) {
			$('.main_wrapper').css('padding-top', padding + 'px');
		} else {
			$('.main_wrapper').css('padding-top', '0px');
		}
	}
	updatePaddingTop();

	$(window).on('resize', function () {
		updatePaddingTop();
	});
});

// シンプルなタブ切り替え機能
document.addEventListener('DOMContentLoaded', function () {
	// セクション4（カリキュラム）のタブ切り替え
	function initTabSwitching(sectionSelector) {
		const section = document.querySelector(`.${sectionSelector}`);
		if (!section) {
			return;
		}

		const sidebarMenuItems = section.querySelectorAll(
			`.academy-course__menu-item`
		);
		const tabContents = section.querySelectorAll(
			`.academy-course__main-content`
		);
		const bottomTags = section.querySelectorAll(
			`.academy-course__bottom-tag`
		);
		const headerMain = section.querySelector(
			`.academy-course__module-main`
		);
		const headerTags = section.querySelectorAll(`.academy-course__tag`);

		// アニメーション実行中フラグ
		let isAnimating = false;

		function switchTab(targetTab) {
			const currentActive = section.querySelector(
				`.academy-course__main-content.active`
			);
			const targetContent = document.getElementById(targetTab);

			// アニメーション中または同じタブの場合は処理を中断
			if (
				isAnimating ||
				!targetContent ||
				currentActive === targetContent
			)
				return;

			// アニメーション開始フラグを立てる
			isAnimating = true;

			// 全てのボタンを非アクティブに
			sidebarMenuItems.forEach((item) => {
				item.classList.remove('active');
			});
			bottomTags.forEach((tag) => {
				tag.classList.remove('active');
			});
			if (headerMain) {
				headerMain.classList.remove('active');
			}
			headerTags.forEach((tag) => {
				tag.classList.remove('active');
			});

			// 対応するボタンをアクティブに
			const correspondingSidebarItem = section.querySelector(
				`.academy-course__menu-item[data-tab="${targetTab}"]`
			);
			if (correspondingSidebarItem) {
				correspondingSidebarItem.classList.add('active');
			}

			const correspondingBottomTag = section.querySelector(
				`.academy-course__bottom-tag[data-tab="${targetTab}"]`
			);
			if (correspondingBottomTag) {
				correspondingBottomTag.classList.add('active');
			}

			const correspondingHeaderBtn = section.querySelector(
				`.academy-course__module-header [data-tab="${targetTab}"]`
			);
			if (correspondingHeaderBtn) {
				correspondingHeaderBtn.classList.add('active');
			}

			// アニメーション付きタブ切り替え
			if (currentActive) {
				// 現在のタブをフェードアウト
				currentActive.classList.add('fade-out');
				currentActive.classList.remove('fade-in');

				// フェードアウト完了後にフェードイン
				setTimeout(() => {
					currentActive.classList.remove('active', 'fade-out');

					// 新しいタブをアクティブに
					targetContent.classList.add('active', 'fade-in');

					// アニメーション完了フラグをリセット
					isAnimating = false;
				}, 300); // フェードアウト時間
			} else {
				// 初回表示時
				tabContents.forEach((content) => {
					content.classList.remove('active', 'fade-out', 'fade-in');
				});
				targetContent.classList.add('active', 'fade-in');

				// アニメーション完了フラグをリセット（初回はすぐに）
				isAnimating = false;
			}
		}

		// 初期化 - 最初のアクティブなコンテンツを取得
		const initialActiveContent = section.querySelector(
			`.academy-course__main-content.active`
		);
		if (initialActiveContent) {
			const initialTab = initialActiveContent.id;
			// 対応するボタンをアクティブにする
			const initialHeaderBtn = section.querySelector(
				`.academy-course__module-header [data-tab="${initialTab}"]`
			);
			if (initialHeaderBtn) {
				initialHeaderBtn.classList.add('active');
			}
			const initialSidebarItem = section.querySelector(
				`.academy-course__menu-item[data-tab="${initialTab}"]`
			);
			if (initialSidebarItem) {
				initialSidebarItem.classList.add('active');
			}
			const initialBottomTag = section.querySelector(
				`.academy-course__bottom-tag[data-tab="${initialTab}"]`
			);
			if (initialBottomTag) {
				initialBottomTag.classList.add('active');
			}
		}

		// イベントリスナーを設定
		sidebarMenuItems.forEach((item) => {
			item.addEventListener('click', function () {
				const targetTab = this.getAttribute('data-tab');
				if (targetTab) {
					switchTab(targetTab);
				}
			});
		});

		bottomTags.forEach((tag) => {
			tag.addEventListener('click', function () {
				const targetTab = this.getAttribute('data-tab');
				if (targetTab) {
					switchTab(targetTab);
				}
			});
		});

		if (headerMain) {
			headerMain.addEventListener('click', function () {
				const targetTab = this.getAttribute('data-tab');
				if (targetTab) {
					switchTab(targetTab);
				}
			});
		}

		headerTags.forEach((tag) => {
			tag.addEventListener('click', function () {
				const targetTab = this.getAttribute('data-tab');
				if (targetTab) {
					switchTab(targetTab);
				}
			});
		});
	}

	// カリキュラムセクションと専門コースセクションのタブ切り替えを初期化
	initTabSwitching('academy-course-curriculum');
	initTabSwitching('academy-course-specialized');
});

// Splideスライダーの初期化
document.addEventListener('DOMContentLoaded', function () {
	// Voice セクションのスライダー
	const voiceSlider = document.querySelector('.splide__voice');
	if (voiceSlider) {
		const splide = new Splide('.splide__voice', {
			type: 'loop',
			autoplay: false,
			interval: 5000,
			arrows: true,
			pagination: false, // カスタムページネーションを使用するため無効化
			gap: '1rem',
			breakpoints: {
				768: {
					arrows: true,
				},
			},
		});

		// スライド数を動的に取得
		const slides = document.querySelectorAll(
			'.splide__voice .splide__slide'
		);
		const totalSlides = slides.length;

		// カスタムページネーション
		const counter = document.querySelector('.academy-voice__counter');
		const dotsContainer = document.querySelector('.academy-voice__dots');

		if (dotsContainer) {
			// ドットを動的生成
			dotsContainer.innerHTML = '';
			for (let i = 0; i < totalSlides; i++) {
				const dot = document.createElement('span');
				dot.className = `academy-voice__dot ${i === 0 ? 'active' : ''}`;
				dot.setAttribute('data-slide', i);
				dotsContainer.appendChild(dot);
			}
		}

		// 初期カウンター設定
		if (counter) {
			counter.innerHTML = `<span>1</span> / ${totalSlides}`;
		}

		// 動的に生成されたドットを取得
		const dots = document.querySelectorAll('.academy-voice__dot');

		// スライド変更時の処理
		splide.on('move', function (newIndex) {
			// カウンター更新
			const displayIndex = (newIndex % totalSlides) + 1;
			if (counter) {
				counter.innerHTML = `<span>${displayIndex}</span> / ${totalSlides}`;
			}

			// ドットの状態更新
			dots.forEach((dot, index) => {
				dot.classList.remove('active');
				if (index === newIndex % totalSlides) {
					dot.classList.add('active');
				}
			});
		});

		// ドットクリックでスライド移動
		dots.forEach((dot, index) => {
			dot.addEventListener('click', function () {
				splide.go(index);
			});
		});

		splide.mount();
	}

	// Flow セクションのスライダー
	const flowSlider = document.querySelector('.splide__flow');
	if (flowSlider) {
		const splideFlow = new Splide('.splide__flow', {
			type: 'loop',
			autoplay: false,
			interval: 5000,
			arrows: true,
			pagination: false, // カスタムページネーションを使用するため無効化
			gap: '1rem',
			breakpoints: {
				768: {
					arrows: false,
				},
			},
		});

		// カスタム矢印の制御
		const customArrows = document.querySelectorAll('.academy-flow__allow');

		customArrows.forEach((arrow) => {
			arrow.addEventListener('click', () => {
				// 次へ進む
				splideFlow.go('+1');
			});
		});

		// スライド数を動的に取得
		const slides_flow = document.querySelectorAll(
			'.splide__flow .splide__slide'
		);
		const totalSlides_flow = slides_flow.length;

		// カスタムページネーション
		const counter_flow = document.querySelector('.academy-flow__counter');
		const dotsContainer_flow = document.querySelector(
			'.academy-flow__dots'
		);

		if (dotsContainer_flow) {
			// ドットを動的生成
			dotsContainer_flow.innerHTML = '';
			for (let i = 0; i < totalSlides_flow; i++) {
				const dot = document.createElement('span');
				dot.className = `academy-flow__dot ${i === 0 ? 'active' : ''}`;
				dot.setAttribute('data-slide', i);
				dotsContainer_flow.appendChild(dot);
			}
		}

		// 初期カウンター設定
		if (counter_flow) {
			counter_flow.innerHTML = `<span>1</span> / ${totalSlides_flow}`;
		}

		// 動的に生成されたドットを取得
		const dots_flow = document.querySelectorAll('.academy-flow__dot');

		// スライド変更時の処理
		splideFlow.on('move', function (newIndex) {
			// カウンター更新
			const displayIndex = (newIndex % totalSlides_flow) + 1;
			if (counter_flow) {
				counter_flow.innerHTML = `<span>${displayIndex}</span> / ${totalSlides_flow}`;
			}

			// ドットの状態更新
			dots_flow.forEach((dot, index) => {
				dot.classList.remove('active');
				if (index === newIndex % totalSlides_flow) {
					dot.classList.add('active');
				}
			});
		});

		// ドットクリックでスライド移動
		dots_flow.forEach((dot, index) => {
			dot.addEventListener('click', function () {
				splideFlow.go(index);
			});
		});

		splideFlow.mount();
	}
});

// Q&A アコーディオン機能
document.addEventListener('DOMContentLoaded', function () {
	const qaItems = document.querySelectorAll('.academy-faq__qa-item');

	qaItems.forEach((item) => {
		const question = item.querySelector('.academy-faq__question');
		const answer = item.querySelector('.academy-faq__answer');
		const icon = item.querySelector('.academy-faq__icon');

		if (question && answer) {
			question.addEventListener('click', function () {
				const isOpen = item.classList.contains('is-open');

				// 他のQ&Aを閉じる（一つずつ開く仕様）
				qaItems.forEach((otherItem) => {
					if (otherItem !== item) {
						otherItem.classList.remove('is-open');
						const otherAnswer = otherItem.querySelector(
							'.academy-faq__answer'
						);
						const otherIcon =
							otherItem.querySelector('.academy-faq__icon');
						if (otherAnswer) {
							otherAnswer.style.maxHeight = '0px';
						}
						if (otherIcon) {
							otherIcon.style.transform = 'rotate(0deg)';
						}
					}
				});

				// 現在のQ&Aをトグル
				if (isOpen) {
					// 閉じる
					item.classList.remove('is-open');
					answer.style.maxHeight = '0px';
					if (icon) {
						icon.style.transform = 'rotate(0deg)';
					}
				} else {
					// 開く
					item.classList.add('is-open');
					answer.style.maxHeight = answer.scrollHeight + 'px';
					if (icon) {
						icon.style.transform = 'rotate(45deg)';
					}
				}
			});
		}
	});
});
